import React, { useEffect, useRef, useState } from 'react';

import { $ } from '../../../base/bootstrap';

const SHOW_MORE_BLOCK_HEIGHT = 65;

export default function ShowMoreBlock({ children }: { children: React.ReactNode }) {
    const block = useRef<HTMLDivElement>();
    const [active, setActive] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const collapse = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        setExpanded(!expanded);
        $(block.current).collapse(expanded ? 'hide' : 'show');
    };

    useEffect(() => {
        if (block.current) {
            const observer = new ResizeObserver(() => {
                setActive(block.current?.scrollHeight > SHOW_MORE_BLOCK_HEIGHT);
            });
            observer.observe(block.current);

            return () => observer.disconnect();
        }

        return null;
    }, [block.current]);

    return (
        <>
            <div ref={block} className={`show-more-block ${active ? 'collapse' : ''}`} aria-expanded="false">
                {children}
            </div>
            {active && (
                <a role="button" className="collapsed" href="#" aria-expanded="false" onClick={collapse}>
                    {expanded ? '- show less' : '+ show more'}
                </a>
            )}
        </>
    );
}
